(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yinn-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-yinn-gallery]');
    if (!root) return;
    var stage = root.querySelector('[data-yinn-stage]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-yinn-thumb]'));
    var countEl = root.querySelector('[data-yinn-count]');
    var index = 0;
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === index);
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === index);
      });
      if (countEl) countEl.textContent = (index + 1) + ' / ' + slides.length;
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-yinn-thumb'), 10)); });
    });
    stage.addEventListener('click', function (e) {
      if (e.target.closest('[data-yinn-prev]') || e.target.closest('[data-yinn-next]')) return;
      next();
    });
    var prevBtn = root.querySelector('[data-yinn-prev]');
    var nextBtn = root.querySelector('[data-yinn-next]');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });
    document.addEventListener('keydown', function (e) {
      var r = root.getBoundingClientRect();
      var inView = r.bottom > 0 && r.top < window.innerHeight;
      if (!inView) return;
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) {
        if (dx < 0) next(); else prev();
      }
      x0 = null;
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
